import { render, staticRenderFns } from "./TrainingAdditionalServices.vue?vue&type=template&id=0452bf88&scoped=true&"
import script from "./TrainingAdditionalServices.vue?vue&type=script&lang=js&"
export * from "./TrainingAdditionalServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452bf88",
  null
  
)

export default component.exports